import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '概览' }
      },
      {
        path: 'products',
        name: 'Product',
        component: () => import('@/views/Product.vue'),
        meta: { title: '账号管理' }
      },
      {
        path: 'card-keys',
        name: 'CardKey',
        component: () => import('@/views/CardKey.vue'),
        meta: { title: '卡密管理' }
      },
      {
        path: 'account-groups',
        name: 'AccountGroupList',
        component: () => import('@/views/AccountGroupList.vue'),
        meta: { title: '分组管理' }
      },
      {
        path: 'account-groups/:id',
        name: 'AccountGroupDetail',
        component: () => import('@/views/AccountGroupDetail.vue'),
        meta: { title: '分组详情' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 卡密系统` : '卡密系统'
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
